module.exports = __webpack_public_path__ + "static/media/Phoenix_Bookcover.f356fd9e.jpg";